export const exploreMenu = {
    main: {
        'title': 'All Categories',
        'image': 'cat-all',
        'translations': {
          'es-ES': {
            'title': 'Todas las Categorías'
          },
          'zh-CN': {
            'title': '所有类别'
          },
          'fr-FR': {
            'title': 'Toutes les catégories'
          },
          'de-DE': {
            'title': 'Alle Kategorien'
          },
          'it-IT': {
            'title': 'Tutte le categorie'
          },
          'ja': {
            'title': 'すべてのカテゴリ'
          },
          'pt-PT': {
            'title': 'Todas as categorias'
          }
        }
    },
    baseAnatomyCategories: [
        {
            'title': 'Male Complete Anatomy',
            'image': 'cat-complete-male',
            'id': 'production/maleAdult/male_complete_anatomy_09',
            'translations': {
              'es-ES': {
                'title': 'Anatomía Completa Masculina'
              },
              'zh-CN': {
                'title': '男性完整解剖学'
              },
              'fr-FR': {
                'title': 'Anatomie complète masculine'
              },
              'de-DE': {
                'title': 'Männliche vollständige Anatomie'
              },
              'it-IT': {
                'title': 'Anatomia Completa Maschile'
              },
              'ja': {
                'title': '男性の完全な解剖学'
              },
              'pt-PT': {
                'title': 'Anatomia Completa Masculina'
              }
            }
        },
        {
            'title': 'Female Complete Anatomy',
            'image': 'cat-complete-female',
            'id': 'production/femaleAdult/female_complete_anatomy_09',
            'translations': {
              'es-ES': {
                'title': 'Anatomía Completa Femenina'
              },
              'zh-CN': {
                'title': '女性完整解剖学'
              },
              'fr-FR': {
                'title': 'Anatomie complète féminine'
              },
              'de-DE': {
                'title': 'Weibliche komplette Anatomie'
              },
              'it-IT': {
                'title': 'Anatomia Completa Femminile'
              },
              'ja': {
                'title': '女性解剖学'
              },
              'pt-PT': {
                'title': 'Anatomia Completa Feminina'
              }
            }
        }
    ],
    categories: [
        {
          'title': 'Anatomy by Systems',
          'tag': 'anatomy-by-system',
          'image': 'cat-anatomy',
          'translations': {
            'es-ES': {
              'title': 'Anatomía por Sistemas'
            },
            'zh-CN': {
              'title': '按系统进行解剖学'
            },
            'fr-FR': {
              'title': 'Anatomie par systèmes'
            },
            'de-DE': {
              'title': 'Anatomie nach Systemen'
            },
            'it-IT': {
              'title': 'Anatomia per sistemi'
            },
            'ja': {
              'title': 'システムによる解剖学'
            },
            'pt-PT': {
              'title': 'Anatomia por Sistemas'
            }
          }
        },
        {
          'title': 'Anatomy by Regions',
          'tag': 'regional',
          'image': 'cat-anatomy-region',
          'translations': {
            'es-ES': {
              'title': 'Anatomía por Regiones'
            },
            'zh-CN': {
              'title': '按地区划分的解剖学'
            },
            'fr-FR': {
              'title': 'Anatomie par régions'
            },
            'de-DE': {
              'title': 'Anatomie nach Regionen'
            },
            'it-IT': {
              'title': 'Anatomia per regioni'
            },
            'ja': {
              'title': '地域別解剖学'
            },
            'pt-PT': {
              'title': 'Anatomia por Regiões'
            }
          }
        },
        {
          'title': 'Blood, Heart and Circulation',
          'tag': 'Blood, Heart and Circulation',
          'image': 'cat-blood-heart',
          'translations': {
            'es-ES': {
              'title': 'Sangre, Corazón y Circulación'
            },
            'zh-CN': {
              'title': '血液、心脏和血液循环'
            },
            'fr-FR': {
              'title': 'Sang, cœur et circulation sanguine'
            },
            'de-DE': {
              'title': 'Blut, Herz und Kreislauf'
            },
            'it-IT': {
              'title': 'Sangue, Cuore e Circolazione'
            },
            'ja': {
              'title': '血液、心臓、循環'
            },
            'pt-PT': {
              'title': 'Sangue, Coração e Circulação'
            }
          }
        },
        {
          'title': 'Bones, Joints and Muscles',
          'tag': 'Bones, Joints and Muscles',
          'image': 'cat-bones-joints-muscles',
          'translations': {
            'es-ES': {
              'title': 'Huesos, Articulaciones y Múscula'
            },
            'zh-CN': {
              'title': '骨骼、关节和肌肉'
            },
            'fr-FR': {
              'title': 'Os, articulations et muscles'
            },
            'de-DE': {
              'title': 'Knochen, Gelenke und Muskeln'
            },
            'it-IT': {
              'title': 'Ossa, articolazioni e muscoli'
            },
            'ja': {
              'title': 'ボーン、ジョイント、マッスル'
            },
            'pt-PT': {
              'title': 'Ossos, articulações e músculos'
            }
          }
        },
        {
          'title': 'Brain and Nerves',
          'tag': 'Brain and Nerves',
          'image': 'cat-brain-nerves',
          'translations': {
            'es-ES': {
              'title': 'Cerebro y Nervios'
            },
            'zh-CN': {
              'title': '大脑和神经'
            },
            'fr-FR': {
              'title': 'Cerveau et nerfs'
            },
            'de-DE': {
              'title': 'Gehirn und Nerven'
            },
            'it-IT': {
              'title': 'Cervello e nervi'
            },
            'ja': {
              'title': '脳と神経'
            },
            'pt-PT': {
              'title': 'Cérebro e Nervos'
            }
          }
        },
        {
          'title': 'Digestive System',
          'tag': 'Digestive System',
          'image': 'cat-digestive-system',
          'translations': {
            'es-ES': {
              'title': 'Sistema Digestivo'
            },
            'zh-CN': {
              'title': '消化系统'
            },
            'fr-FR': {
              'title': 'Système digestif'
            },
            'de-DE': {
              'title': 'Verdauungssystem'
            },
            'it-IT': {
              'title': 'Apparato Digestivo'
            },
            'ja': {
              'title': '消化器系'
            },
            'pt-PT': {
              'title': 'Sistema Digestivo'
            }
          }
        },
        {
          'title': 'Ear, Nose and Throat',
          'tag': 'Ear, Nose and Throat',
          'image': 'cat-ear-nose-throat',
          'translations': {
            'es-ES': {
              'title': 'Oído, Nariz y Garganta'
            },
            'zh-CN': {
              'title': '耳鼻喉科'
            },
            'fr-FR': {
              'title': 'Oreille, Nez et Gorge'
            },
            'de-DE': {
              'title': 'Ohr, Nase und Hals'
            },
            'it-IT': {
              'title': 'Orecchio, naso e gola'
            },
            'ja': {
              'title': '耳・鼻・喉'
            },
            'pt-PT': {
              'title': 'Orelha, nariz e garganta'
            }
          }
        },
        {
          'title': 'Endocrine System',
          'tag': 'Endocrine System',
          'image': 'cat-endocrine-system',
          'translations': {
            'es-ES': {
              'title': 'Sistema Endocrino'
            },
            'zh-CN': {
              'title': '内分泌系统'
            },
            'fr-FR': {
              'title': 'Système endocrinien'
            },
            'de-DE': {
              'title': 'Endokrine System'
            },
            'it-IT': {
              'title': 'Sistema Endocrino'
            },
            'ja': {
              'title': '内分泌系'
            },
            'pt-PT': {
              'title': 'Sistema endócrino'
            }
          }
        },
        {
          'title': 'Eyes and Vision',
          'tag': 'Eyes and Vision',
          'image': 'cat-eyes-vision',
          'translations': {
            'es-ES': {
              'title': 'Ojos y Visión'
            },
            'zh-CN': {
              'title': '眼睛和视力'
            },
            'fr-FR': {
              'title': 'Yeux et vision'
            },
            'de-DE': {
              'title': 'Augen und Sehkraft'
            },
            'it-IT': {
              'title': 'Occhi e Visione'
            },
            'ja': {
              'title': '目とビジョン'
            },
            'pt-PT': {
              'title': 'Olhos e Visão'
            }
          }
        },
        {
          'title': 'Immune System',
          'tag': 'Immune System',
          'image': 'cat-immune-system',
          'translations': {
            'es-ES': {
              'title': 'Sistema Inmunológico'
            },
            'zh-CN': {
              'title': '免疫系统'
            },
            'fr-FR': {
              'title': 'Système immunitaire'
            },
            'de-DE': {
              'title': 'Immunsystem'
            },
            'it-IT': {
              'title': 'Sistema immunitario'
            },
            'ja': {
              'title': '免疫系'
            },
            'pt-PT': {
              'title': 'Sistema Imunitário'
            }
          }
        },
        {
          'title': 'Kidneys and Urinary System',
          'tag': 'Kidneys and Urinary System',
          'image': 'cat-kidney-urinary',
          'translations': {
            'es-ES': {
              'title': 'Riñones y Sistema Urinario'
            },
            'zh-CN': {
              'title': '肾脏和泌尿系统'
            },
            'fr-FR': {
              'title': 'Reins et système urinaire'
            },
            'de-DE': {
              'title': 'Nieren und Harnwege'
            },
            'it-IT': {
              'title': 'Reni e sistema urinario'
            },
            'ja': {
              'title': '腎臓と泌尿器系'
            },
            'pt-PT': {
              'title': 'Rins e Sistema Urinário'
            }
          }
        },
        {
          'title': 'Lungs and Breathing',
          'tag': 'Lungs and Breathing',
          'image': 'cat-lungs-breathing',
          'translations': {
            'es-ES': {
              'title': 'Pulmones y Respiración'
            },
            'zh-CN': {
              'title': '肺和呼吸'
            },
            'fr-FR': {
              'title': 'Poumons et respiration'
            },
            'de-DE': {
              'title': 'Lunge und Atmung'
            },
            'it-IT': {
              'title': 'Polmoni e Respirazione'
            },
            'ja': {
              'title': '肺と呼吸'
            },
            'pt-PT': {
              'title': 'Pulmões e respiração'
            }
          }
        },
        {
          'title': 'Mouth and Teeth',
          'tag': 'Mouth and Teeth',
          'image': 'cat-mouth-teeth',
          'translations': {
            'es-ES': {
              'title': 'Boca y Dientes'
            },
            'zh-CN': {
              'title': '口腔和牙齿'
            },
            'fr-FR': {
              'title': 'Bouche et dents'
            },
            'de-DE': {
              'title': 'Mund und Zähne'
            },
            'it-IT': {
              'title': 'Bocca e Denti'
            },
            'ja': {
              'title': '口と歯'
            },
            'pt-PT': {
              'title': 'Boca e Dentes'
            }
          }
        },
        {
          'title': 'Skin, Hair and Nails',
          'tag': 'Skin, Hair and Nails',
          'image': 'cat-skin-hair-nails',
          'translations': {
            'es-ES': {
              'title': 'Piel, Pelo y Uñas'
            },
            'zh-CN': {
              'title': '皮肤、头发和指甲'
            },
            'fr-FR': {
              'title': 'Peau, cheveux et ongles'
            },
            'de-DE': {
              'title': 'Haut, Haare und Nägel'
            },
            'it-IT': {
              'title': 'Pelle, Capelli e Unghie'
            },
            'ja': {
              'title': '肌、髪、爪'
            },
            'pt-PT': {
              'title': 'Pele, Cabelo e Unhas'
            }
          }
        },
        {
          'title': 'Female Reproductive System',
          'tag': 'Female Reproductive System',
          'image': 'cat-female-reproductive',
          'translations': {
            'es-ES': {
              'title': 'Sistema Reproductivo Femenino'
            },
            'zh-CN': {
              'title': '女性生殖系统'
            },
            'fr-FR': {
              'title': 'Système reproducteur féminin'
            },
            'de-DE': {
              'title': 'Weibliches Fortpflanzungssystem'
            },
            'it-IT': {
              'title': 'Sistema riproduttivo femminile'
            },
            'ja': {
              'title': '女性の生殖器系'
            },
            'pt-PT': {
              'title': 'Sistema Reprodutivo Feminino'
            }
          }
        },
        {
          'title': 'Male Reproductive System',
          'tag': 'Male Reproductive System',
          'image': 'cat-male-reproductive',
          'translations': {
            'es-ES': {
              'title': 'Sistema Reproductivo Masculino'
            },
            'zh-CN': {
              'title': '男性生殖系统'
            },
            'fr-FR': {
              'title': 'Système reproducteur masculin'
            },
            'de-DE': {
              'title': 'Männliches Fortpflanzungssystem'
            },
            'it-IT': {
              'title': 'Sistema riproduttivo maschile'
            },
            'ja': {
              'title': '生殖器系'
            },
            'pt-PT': {
              'title': 'Sistema Reprodutor Masculino'
            }
          }
        },
        {
          'title': 'Community Bookmarks',
          'tag': 'public',
          'image': 'cat-community',
          'translations': {
            'es-ES': {
              'title': 'Marcadores de la Comunidad'
            },
            'zh-CN': {
              'title': '社区书签'
            },
            'fr-FR': {
              'title': 'Signets de la communauté'
            },
            'de-DE': {
              'title': 'Community-Lesezeichen'
            },
            'it-IT': {
              'title': 'Segnalibri della Comunità'
            },
            'ja': {
              'title': 'コミュニティブックマーク'
            },
            'pt-PT': {
              'title': 'Marcadores da Comunidade'
            }
          }
        }
      ]
};
